import type { FC, ReactNode } from 'react';
import styles from './Eyebrow.module.css';

interface EyebrowProps {
  children: ReactNode;
  tone?: 'default' | 'inverse';
}

export const Eyebrow: FC<EyebrowProps> = ({ children, tone = 'default' }) => {
  return (
    <span className={[styles.root, styles[`tone_${tone}`]].join(' ')}>
      <span className={styles.dot} aria-hidden="true" />
      {children}
    </span>
  );
};

Eyebrow.displayName = 'Eyebrow';
